import { Link, graphql, useStaticQuery } from "gatsby"
import React from "react"
import styled from "styled-components"
import { device } from "../utils/device"
import LogoDark from "./main-page/LogoDark"

const StyledLink = styled(Link)`
  text-decoration: none;
  color: #4a4a68;
`

const StyledA = styled.a`
  text-decoration: none;
  color: #4a4a68;
`

const Container = styled.footer`
  justify-content: center;
  padding: 20px;
  background: #ecf1f4;
  color: #4a4a68;

  @media ${device.tablet} {
    flex-direction: column;
    padding: 5px;
  }

  h3 {
    font-size: 14px;
    text-transform: uppercase;
  }
`

const LogoWrapper = styled(Link)`
  flex: 0 0 60px;
`

const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 150px;
  height: 100%;

  @media ${device.tablet} {
    flex-direction: column;
    place-content: center;
    align-self: center;
    order: 10;
  }
`

const FlexRow = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: flex-start;
  padding: 40px 0;
  width: 100%;

  h3 {
    margin-bottom: 5px;
    height: 19px;
  }

  & > div {
    margin-right: 50px;
    @media (max-width: 870px) {
      margin-right: 20px;
    }
    @media ${device.tablet} {
      margin-right: 0;
    }
  }

  @media ${device.tablet} {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 0 20px;
    margin-right: 0;

    div:last-child {
      padding: 0;
    }
    h3 {
      margin-top: 20px;
    }
  }
`

const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;

  a {
    font-family: "Nunito Sans", sans-serif;
    font-weight: 300;
    font-size: 14px;
    margin: 5px 0;
    cursor: pointer;

    &:hover {
      color: ${props => props.theme.colors.darkOrange};
    }
  }
`

const Social = styled.div`
  padding-bottom: 15px;
  font-family: "Nunito Sans", sans-serif;
  font-size: 14px;
  color: #8C8CA1;
  img {
    width: auto;
    height: 24px;
  }
  p {
    padding-bottom: 10px;
  }

  a {
    padding-right: 10px;
  }
`

const Copyright = styled.div`
  padding-bottom: 15px;
  font-family: "Nunito Sans", sans-serif;
  font-size: 12px;
  color: #8C8CA1;
  text-align: center;
`

function Footer() {
  const data = useStaticQuery(graphql`
    query FooterQuery {
      strapiFooter {
        LinkGroup {
          Header
          Link {
            Reference
            Text
          }
        }
        Social {
          Name
          LinkUrl
          Icon {
            localFile {
              publicURL
            }
            width
            height
          }
        }
      }
    }
  `)

  const columns = data.strapiFooter.LinkGroup;
  const socials = data.strapiFooter.Social;
  const year = new Date().getFullYear();

  const localLinkRegEx = new RegExp(/^\//)
  const isLocalLink = (link) => {
    return localLinkRegEx.test(link.Reference);
  }

  return (
    <Container>
      <FlexRow>
        <LogoContainer>
          <LogoWrapper to="/">
            <LogoDark />
          </LogoWrapper>
          <Social>
            <p>Connect with us</p>
            <p>
              {socials.map((social, index) => (
                <a href={social.LinkUrl} target="_blank" rel="noopener" key={index}>
                  <img src={social.Icon.localFile.publicURL} alt={social.Name} width="1" height="1" />
                </a>
              ))}
            </p>
          </Social>
        </LogoContainer>
        {columns.map((column, i) => (
          <FlexColumn key={i}>
            <h3>{column.Header}</h3>
            {column.Link.map((link, index) => {
              return isLocalLink(link) ?
                  <StyledLink to={link.Reference} key={index}>
                    {link.Text}
                  </StyledLink>
                :
                  <StyledA href={link.Reference} key={index}>
                    {link.Text}
                  </StyledA>
            })}
          </FlexColumn>
        ))}
      </FlexRow>
      <Copyright>
        <p>Copyright © 2019-{year} Alooba Pty Ltd. All Rights Reserved.</p>
      </Copyright>
    </Container>
  )
}

export default Footer
